package org.example.willfreightnew.components.models

import org.example.willfreightnew.components.util.Constants
import org.example.willfreightnew.components.util.Res

enum class Contact(
    val icon: String,
    val imageDesc: String,
    val title: String,
    val description: String
) {
    Address(
        icon = Res.Image.ADDRESS_ICON,
        imageDesc = "Address Icon",
        title = "Address",
        description = Constants.ADDRESS_DESC
    ),
    Details(
        icon = Res.Image.CONTACT_ICON,
        imageDesc = "Contact Icon",
        title = "Contact",
        description = Constants.CONTACT_DESC
    )
}